
// PAGES 
import login_page from './login.js';
import account_page from './account.js';
import apikeys from './api-keys.js';
import dashboard from './dashboard.js';
import grapeuilogout_page from './grapeui_logout.js';


import account from './account-pages/account.js';
import acc_overview from './account-pages/overview/acc-overview.js';
import acc_info from './account-pages/info/acc-info.js';
import acc_advanced_settings from './account-pages/advanced/acc-advancedSettings.js';

import grapeui_password_reset_page from './new_password.js';

export default [
	login_page,
	grapeuilogout_page,
	grapeui_password_reset_page,
	apikeys,
	dashboard,
	account,
	acc_overview,
	acc_info,
	acc_advanced_settings
];

